import { UseQueryOptions } from '@tanstack/react-query';

import { equipmentBrowserGetEquipmentDetails } from '@repo/sdk/funcs/equipmentBrowserGetEquipmentDetails';
import { EquipmentDetailsResponse } from '@repo/sdk/models/components';
import { SDKError } from '@repo/sdk/models/errors';
import { GetEquipmentDetailsRequest } from '@repo/sdk/models/operations';

import { GaiaClientFunction } from '@/client/types';
import { displayTemplateSourceKey } from '@/queries/gaia-api/display-template-source-key';
import { GaiaQueryWithAgentId } from '@/queries/types';

interface GetEquipmentDetailsQueryProps extends GaiaQueryWithAgentId {
  client: GaiaClientFunction;
  deviceId: string;
}

export const getEquipmentDetailsQuery = ({
  agentId,
  deviceId,
  client,
}: GetEquipmentDetailsQueryProps): UseQueryOptions<
  EquipmentDetailsResponse,
  SDKError,
  EquipmentDetailsResponse | undefined
> => {
  return {
    enabled: !!agentId && !!deviceId,
    queryKey: [agentId, 'getEquipmentDetails', deviceId, displayTemplateSourceKey(client)],
    queryFn: () =>
      client<GetEquipmentDetailsRequest, EquipmentDetailsResponse>({
        gaiaFunc: equipmentBrowserGetEquipmentDetails,
        request: {
          agentId: agentId!,
          deviceId: deviceId!,
        },
      }),
    staleTime: Infinity,
  };
};
